export const common = {
  nav: {
    quemSomos: 'About Us',
    servicos: 'Services',
    portfolio: 'Portfolio',
    processo: 'Process',
    pedirOrcamento: 'Get a Quote'
  },
  hero: {
    titulo: 'If you don\'t show up,',
    titulo2: 'you don\'t sell.',
    subtitulo: 'Agency specialized in strategy, social media, branding and professional audiovisual production.',
    botaoOrcamento: 'Get a Quote',
    botaoWhatsapp: 'WhatsApp'
  },
  quemSomos: {
    titulo: 'We transform brands into references.',
    texto1: '<strong>Olhar Criativo</strong> is a strategic agency focused on real results. We don\'t just make pretty posts — we build positioning, authority and sustainable growth for brands that want to dominate their market.',
    texto2: 'We combine digital marketing strategy, high-end audiovisual production and sophisticated design to create experiences that convert followers into loyal customers.'
  },
  servicos: {
    titulo: 'Services that deliver results',
    subtitulo: 'Complete marketing and creative production solutions for brands that want to grow with strategy and professionalism.',
    gestaoRedes: 'Social Media Management',
    gestaoRedesDesc: 'Complete strategy for Instagram, Facebook and TikTok. We create content that generates real engagement, increases qualified followers and transforms your digital presence into a sales machine.',
    gestaoRedesDetalhes: 'Our social media management in Algarve includes strategic content planning, optimized posts for each platform, community management with quick responses, performance metrics analysis and detailed monthly reports. We work with Instagram, Facebook and TikTok algorithms to maximize organic reach and create an engaged audience that converts into real sales for your business.',
    producaoConteudo: 'Content Production',
    producaoConteudoDesc: 'Professional photography and video that elevate your brand perception. We produce high-impact visual content that sets your business apart from the competition and attracts the ideal customer.',
    producaoConteudoDetalhes: 'We offer complete audiovisual production services including professional commercial photography, promotional videos, reels for Instagram and TikTok, event coverage, product photography, corporate videos and brand documentaries. We use state-of-the-art equipment and visual storytelling techniques to create content that moves, inspires and converts. Each production is strategically planned to communicate your brand values and generate measurable results.',
    designGrafico: 'Graphic Design',
    designGraficoDesc: 'Strategic design that communicates your brand essence. We create visual identity, graphic materials and posts that convey professionalism and authority in every detail.',
    designGraficoDetalhes: 'Our graphic design services include logo creation, corporate visual identity, brochure and catalog design, business cards, promotional materials, social media design, digital banners, business presentations and packaging. Each project is developed with attention to detail, following modern design best practices and ensuring visual consistency across all touchpoints of your brand with the public.',
    branding: 'Branding',
    brandingDesc: 'We build memorable brands from scratch or reposition existing businesses. We develop complete identity, tone of voice and positioning strategy that differentiates in the market.',
    brandingDetalhes: 'Our complete branding process includes market research and competitive analysis, unique value proposition definition, naming and tagline creation, visual identity development (logo, color palette, typography), detailed brand manual, tone of voice and brand personality, positioning strategy and practical applications across various materials. We create authentic brands that emotionally resonate with the target audience and build long-term loyalty.',
    trafegoPago: 'Paid Traffic',
    trafegoPagoDesc: 'Meta Ads and Google Ads campaigns optimized for conversion. We invest your budget intelligently to generate qualified leads and real sales, not just clicks.',
    trafegoPagoDetalhes: 'We manage digital advertising campaigns on Meta Ads (Facebook and Instagram), Google Ads (search, display, YouTube), LinkedIn Ads and other relevant platforms. Our service includes keyword research, persuasive ad creation, advanced audience targeting, continuous A/B testing, landing page optimization, strategic remarketing and transparent ROI reports. We focus on metrics that matter: cost per acquisition, conversion rate and return on advertising investment.',
    estrategiaDigital: 'Digital Strategy',
    estrategiaDigitalDesc: 'Complete digital marketing planning aligned with your business objectives. We analyze the market, define clear goals and create the path to sustainable growth.',
    estrategiaDigitalDetalhes: 'We develop personalized digital strategies that include complete audit of current digital presence, SWOT analysis and competitive benchmarking, persona definition and customer journey, multi-channel content planning, SEO and content marketing strategy, optimized sales funnel, KPIs and success metrics, editorial calendar and implementation roadmap. Each strategy is based on real data and focused on generating measurable and sustainable growth for your business in the digital market.',
    verMais: 'Learn more',
    verMenos: 'Show less',
    porqueEscolher: 'Why choose Olhar Criativo?',
    experiencia: 'Proven Experience',
    experienciaDesc: 'Years of experience working with brands from various sectors in Algarve and Portugal, delivering consistent and measurable results.',
    equipa: 'Specialized Team',
    equipaDesc: 'Certified professionals in digital marketing, design, photography and audiovisual production, always updated with the latest trends and tools.',
    resultados: 'Results Focused',
    resultadosDesc: 'We don\'t work with vanity metrics. Our commitment is to generate real growth, sales and positive ROI for your marketing investment.'
  },
  portfolio: {
    titulo: 'Portfolio',
    subtitulo: 'Some of our recent work',
    restaurante: 'Restaurant',
    hamburgueria: 'Burger Joint',
    steakhouse: 'Steakhouse',
    sushi: 'Sushi',
    spa: 'Spa & Wellness',
    pastelaria: 'Pastry Shop',
    wine: 'Wine Bar',
    architecture: 'Architecture',
    catFotografia: 'Photography & Branding',
    catProducao: 'Audiovisual Production',
    catGestao: 'Social Media Management',
    catBranding: 'Complete Branding',
    catEstrategia: 'Digital Strategy',
    catConteudo: 'Visual Content'
  },
  processo: {
    titulo: 'How we work',
    subtitulo: 'A structured and transparent process that ensures predictable results and consistent growth.',
    diagnostico: 'Diagnosis',
    diagnosticoDesc: 'We analyze your business, market and competition to identify growth opportunities and differentiation points.',
    estrategia: 'Strategy',
    estrategiaDesc: 'We develop a personalized plan with clear objectives, defined target audience and specific tactics to achieve results.',
    producao: 'Production',
    producaoDesc: 'We create high-impact visual content, professional graphic materials and campaigns that capture attention and generate desire.',
    publicacao: 'Publication',
    publicacaoDesc: 'We implement the strategy consistently, managing all platforms and optimizing each publication for maximum reach.',
    crescimento: 'Growth',
    crescimentoDesc: 'We monitor results, adjust tactics and scale what works to ensure continuous and sustainable growth.'
  },
  depoimentos: {
    titulo: 'What our clients say',
    subtitulo: 'Real results from brands that trusted our strategy and grew sustainably.',
    depoimento1: 'Olhar Criativo completely transformed our digital presence. In 6 months, we tripled the number of bookings from social media. Their work is impeccable.',
    depoimento2: 'Professionalism from start to finish. The team perfectly understood our vision and created a visual identity that sets us apart in the market. I recommend without hesitation.',
    depoimento3: 'We finally found an agency that delivers real results. The ROI of paid traffic campaigns exceeded all expectations. A partnership to continue.',
    proprietario: 'Owner',
    diretora: 'Marketing Director',
    ceo: 'CEO'
  },
  formulario: {
    titulo: 'Ready to grow?',
    subtitulo: 'Fill out the form and receive a personalized proposal to transform your business digital presence.',
    nome: 'Full Name',
    nomePlaceholder: 'Your name',
    empresa: 'Company',
    empresaPlaceholder: 'Company name',
    area: 'Business Area',
    areaPlaceholder: 'Select an option',
    restauracao: 'Restaurant',
    hotelaria: 'Hospitality',
    moda: 'Fashion',
    beleza: 'Beauty & Wellness',
    comercio: 'Local Commerce',
    servicosPro: 'Professional Services',
    outro: 'Other',
    objetivo: 'Main Objective',
    objetivoPlaceholder: 'Describe what you want to achieve (max. 500 characters)',
    orcamento: 'Approximate Budget',
    telefone: 'Phone',
    telefonePlaceholder: '+351 910 000 000',
    enviar: 'Send Quote Request',
    enviando: 'Sending...',
    sucesso: '✓ Request sent successfully! We will contact you shortly.',
    erro: '✗ Error sending. Please try again.',
    caracteres: 'characters'
  },
  footer: {
    descricao: 'Digital marketing and creative production agency specialized in transforming brands into market references through strategy, design and professional content.',
    servicos: 'Services',
    contacto: 'Contact',
    direitos: 'All rights reserved.'
  }
};
